// forms.js - Dependencias: cookie.js
(function () {
    'use strict';

    var forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
        .forEach(function (form) {
            let isSubmitting = false; // Variable de control para prevenir múltiples envíos
            
            form.addEventListener('submit', function (event) {
                event.preventDefault();

                // Prevenir múltiples envíos
                if (isSubmitting) {
                    console.log('Formulario ya en proceso de envío...');
                    return;
                }

                // Marcar como enviando y deshabilitar el botón inmediatamente
                isSubmitting = true;
                
                var submitButton = form.querySelector('.form-submit-button');
                
                if (submitButton) {
                    submitButton.disabled = true;
                    submitButton.classList.add('is_loading');
                }

                form.classList.add('was-validated');

                if (!form.checkValidity()) {
                    // Si hay errores de validación, reactivar el formulario
                    isSubmitting = false;
                    
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.classList.remove('is_loading');
                    }
                    
                    console.log('Formulario no válido');
                    return;
                }

                form.classList.remove('was-validated');
                console.log('Formulario válido');

                // Procesar datos del formulario
                var formObject = {};
                var formDataApi = {};
                var formData = new FormData(form);
                formData.forEach(function (value, key) {
                    formObject[key] = value;
                });

                // arreglo para mapear titulaciones presenciales y online 
                const titulacionesMap = {
                    'ANIV': 'ANID',
                    'DIPI': 'DIPD',
                    'DIDI': 'DIDD',
                    'INSO': 'INSD',
                    'ASIR': 'ASID',
                    'AJEI': 'AJED',
                    'DAMP': 'DAMD',
                    'DAWE': 'DAWD',
                    'PAAN': 'PA3D',
                };

                console.log(formObject);

                var titulaciones = [];
                titulaciones.push(formObject['titulaciones']);
                formDataApi['titulaciones'] = titulaciones;
                formDataApi['nombre'] = formObject['nombre'];
                formDataApi['apellido1'] = formObject['apellido1'];
                formDataApi['apellido2'] = "";
                formDataApi['email'] = formObject['email'];
                formDataApi['telefono'] = formObject['telefono'].replace(/\s+/g, ''); // Quitar espacios en blanco
                formDataApi['situacionactual'] = formObject['situacionactual'];
                formDataApi['pais'] = formObject['pais'];
                formDataApi['codigopostal'] = formObject['codigopostal'];
                formDataApi['autorizawhatsapp'] = formObject['autorizawhatsapp'] || 'false';
                formDataApi['aceptalpd'] = formObject['aceptalpd'] || 'false';
                formDataApi['mktcontacto'] = '';
                formDataApi['mktlead'] = '';
                formDataApi['bachilleratoartistico'] = formObject['bachilleratoartistico'] || 'false';
                formDataApi['tema'] = "API - OKB - Web";

                // si llega formato_estudio con valor online, entonces mapear titulaciones con el arreglo titulacionesMap
                if (formObject['formato_estudio'] === 'online') {
                    // Asegurarse de que titulaciones sea un array antes de usar map
                    const titulacionesArray = Array.isArray(formObject['titulaciones']) 
                        ? formObject['titulaciones'] 
                        : [formObject['titulaciones']];
                    
                    formDataApi['titulaciones'] = titulacionesArray.map(titulacion => titulacionesMap[titulacion] || titulacion);
                }

                console.log(formDataApi);

                let decodedCookie = getDecodedCookieValue('utaddmf');
                console.log(decodedCookie);
                
                if (decodedCookie) {
                    let mktcontactoValue = getMktContactoValue(decodedCookie);
                    let mktleadValue = getMktLeadValue(decodedCookie);

                    console.log(mktcontactoValue);
                    console.log(mktleadValue);

                    if (mktcontactoValue) {
                        formDataApi['mktcontacto'] = mktcontactoValue;
                    }

                    if (mktleadValue) {
                        formDataApi['mktlead'] = mktleadValue;
                    }
                }

                // Modifica el número de teléfono solo si el campo de teléfono y país están presentes y no están vacíos
                if (formDataApi['telefono'] && formDataApi['pais']) {
                    const countryCode = getCountryCode(formDataApi['pais']);
                    // Asegúrate de que el número de teléfono no comienza ya con el código del país
                    if (formDataApi['telefono'].indexOf(countryCode) !== 0) {
                        formDataApi['telefono'] = countryCode + formDataApi['telefono'];
                    }
                }

                console.log('Form Data Api:', formDataApi);

                var jsonString = JSON.stringify(formDataApi);
                console.log(jsonString);
                var encodedData = btoa(jsonString);

                var finalFormData = new FormData(); 
                finalFormData.append("token", formObject['token']);
                finalFormData.append("data", encodedData);

                console.log('FINAL Form Data Api:', finalFormData);
                console.log(formObject['redirection']);

                // Envío AJAX con mejor manejo de errores
                var xhr = new XMLHttpRequest();
                xhr.open("POST", environmentJs, true);
                xhr.timeout = 30000; // Timeout de 30 segundos
                
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        try {
                            var responseJson = JSON.parse(xhr.responseText);
                            console.log('Response JSON:', responseJson);
                            
                            if (responseJson.statusCode === 201) {
                                // Éxito - procesar respuesta
                                var currentUrl = formObject['redirection'] || 'https://u-tad.com/gracias';
                                
                                console.log(responseJson);

                                var countryPhone = formObject['telefono'].replace(/\s+/g, ''); // Quitar espacios en blanco
                                const countryCode = getCountryCode(formObject['pais']);
                                if (formObject['telefono'].indexOf(countryCode) !== 0) {
                                    countryPhone = countryCode + formObject['telefono'];
                                } else {
                                    countryPhone = formObject['telefono'];
                                }

                                window.dataLayer = window.dataLayer || [];

                                // por cada dmf_leadGuid en el array leadsGuid crear un dmf_leadGuid1, dmf_leadGuid2, dmf_leadGuid3, dmf_leadGuid4, dmf_leadGuid5
                                for (let i = 0; i < responseJson.leadsGuid.length; i++) {
                                    dataLayer.push({
                                        ['dmf_leadGuid' + (i + 1)]: responseJson.leadsGuid[i]
                                    });
                                }

                                dataLayer.push({
                                    'event': 'formcompleteregistration',
                                    'dmf_email': formObject['email'],
                                    'dmf_phone': countryPhone,
                                    'dmf_contactGuid': responseJson.contactGuid,
                                });

                                console.log(dataLayer);
                                window.location = currentUrl;
                                
                            } else {
                                console.log('Error del servidor:', responseJson);
                                resetFormState();
                            }
                        } catch (e) {
                            console.log('Error parsing response:', e);
                            resetFormState();
                        }
                    }
                };

                xhr.onerror = function () {
                    console.log('Error de red en el envío del formulario');
                    resetFormState();
                };

                xhr.ontimeout = function () {
                    console.log('Timeout en el envío del formulario');
                    resetFormState();
                };

                function resetFormState() {
                    isSubmitting = false;
                    
                    if (submitButton) {
                        submitButton.disabled = false;
                        submitButton.classList.remove('is_loading');
                    }
                }

                xhr.send(finalFormData);
            }, false);
        });
})();

document.addEventListener('DOMContentLoaded', function() {
    const countrySelect = document.getElementById('courseFormCountry');
    const zipInput = document.getElementById('courseFormZip');
    const situacionActual = document.getElementById('courseFormStatus');

    if(countrySelect) {
        countrySelect.addEventListener('change', function() {
            if (countrySelect.value === 'ES') {
                zipInput.disabled = false;
                zipInput.required = true; 
                zipInput.value = '';// Asegura que sea obligatorio si está habilitado
            } else {
                zipInput.disabled = true;
                zipInput.value = 'N/P'; // Limpia el valor
                zipInput.required = false; // No es obligatorio si está deshabilitado
            }
        });
    }

    if (situacionActual) {
        situacionActual.addEventListener('change', function() {
    
            // si existe el elemento con id checkbox_bachillerato_artistico_container
            // si el valor es 100000008 o 100000003 display block #checkbox_bachillerato_artistico_container, si no display none
            
            const bachilleratoArtisticoContainer = document.getElementById('checkbox_bachillerato_artistico_container');
    
            if (bachilleratoArtisticoContainer) {
                if (situacionActual.value === '100000008' || situacionActual.value === '100000003') {
                    bachilleratoArtisticoContainer.style.display = 'block';
                } else {
                    bachilleratoArtisticoContainer.style.display = 'none';
                }
            }
    
        });
    }

    var button = document.getElementById('courseFormCtaButton'); // O usa document.querySelector('.mi-clase-especifica');
    var buttonClose = document.getElementById('courseFormCtaButtonClose'); // O usa document.querySelector('.mi-clase-especifica');
    // Agregar el evento click al botón
    if (button) {
        button.addEventListener('click', toggleFormVisibility);
        buttonClose.addEventListener('click', toggleFormVisibility);
    }

    // Función para mostrar/ocultar el formulario y hacer scroll
    function toggleFormVisibility() {
        var div = document.getElementById('courseFormCta');
        div.classList.toggle('is_show-form');

        // Hacer scroll hasta el div
        div.scrollIntoView({ behavior: 'smooth' });
    }

});

// Función para mostrar/ocultar el formulario
function toggleFormVisibility() {
    var div = document.getElementById('courseFormCTA');
    console.log(div);
    div.classList.toggle('is_show-form');

    // Scroll hasta el div
    div.scrollIntoView({ behavior: 'smooth' });
}



function getMktContactoValue(cookieData) {
    if (cookieData) {
        return `${cookieData.contact_channel},${cookieData.contact_medium},${cookieData.contact_campaign},${cookieData.contact_detail},${cookieData.contact_dest},${cookieData.contact_type},${cookieData.contact_platform}`;
    }
    return null;
}

function getMktLeadValue(cookieData) {
    if (cookieData) {
        return `${cookieData.lead_channel},${cookieData.lead_medium},${cookieData.lead_campaign},${cookieData.lead_detail},${cookieData.lead_dest},${cookieData.lead_type},${cookieData.lead_platform}`;
    }
    return null;
}

function getCookie(name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}

function getDecodedCookieValue(cookieName) {
    let cookieValue = getCookie(cookieName);

    if (cookieValue) {
        // Convertir backslashes (\) en entidades HTML (%20)
        let decodedValue = decodeURIComponent(cookieValue.replace(/\+/g, '%20'));
        return JSON.parse(decodedValue);
    }

    return null;
}

function getCountryCode(countryValue) {
    const countryCodeMap = {
        "ES": "+34", "AF": "+93", "AL": "+355", "DE": "+49", "AD": "+376", "AO": "+244", "AI": "+1-264", "AQ": "+672",
        "AG": "+1-268", "SA": "+966", "DZ": "+213", "AR": "+54", "AM": "+374", "AW": "+297", "AU": "+61", "AT": "+43",
        "AZ": "+994", "BS": "+1-242", "BD": "+880", "BB": "+1-246", "BH": "+973", "BE": "+32", "BZ": "+501", "BJ": "+229",
        "BM": "+1-441", "BY": "+375", "BO": "+591", "BA": "+387", "BW": "+267", "BR": "+55", "BN": "+673", "BG": "+359",
        "BF": "+226", "BI": "+257", "BT": "+975", "CV": "+238", "KY": "+1-345", "KH": "+855", "CM": "+237", "CA": "+1",
        "QA": "+974", "CF": "+236", "TD": "+235", "CZ": "+420", "CL": "+56", "CN": "+86", "CY": "+357", "CC": "+61",
        "CO": "+57", "KM": "+269", "CG": "+242", "CD": "+243", "CK": "+682", "KP": "+850", "KR": "+82", "CI": "+225",
        "CR": "+506", "HR": "+385", "CU": "+53", "CW": "+599", "DK": "+45", "DM": "+1-767", "DO": "+1-809 and 1-829",
        "EC": "+593", "EG": "+20", "AE": "+971", "ER": "+291", "SK": "+421", "SI": "+386", "US": "+1", "EE": "+372",
        "SZ": "+268", "ET": "+251", "FO": "+298", "PH": "+63", "FI": "+358", "FJ": "+679", "FR": "+33", "GA": "+241",
        "GM": "+220", "GE": "+995", "GH": "+233", "GI": "+350", "GD": "+1-473", "GR": "+30", "GL": "+299", "GU": "+1-671",
        "GT": "+502", "GG": "+44-1481", "GN": "+224", "GQ": "+240", "GW": "+245", "GY": "+592", "HT": "+509", "HN": "+504",
        "HK": "+852", "HU": "+36", "IN": "+91", "ID": "+62", "IQ": "+964", "IR": "+98", "IE": "+353", "IS": "+354",
        "IL": "+972", "IT": "+39", "JM": "+1-876", "JP": "+81", "JE": "+44-1534", "JO": "+962", "KZ": "+7", "KE": "+254",
        "KG": "+996", "KI": "+686", "KW": "+965", "LA": "+856", "LS": "+266", "LV": "+371", "LB": "+961", "LR": "+231",
        "LY": "+218", "LI": "+423", "LT": "+370", "LU": "+352", "MO": "+853", "MK": "+389", "MG": "+261", "MY": "+60",
        "MW": "+265", "MV": "+960", "ML": "+223", "MT": "+356", "FK": "+500", "IM": "+44-1624", "MP": "+1-670", "MA": "+212",
        "MH": "+692", "MU": "+230", "MR": "+222", "MX": "+52", "FM": "+691", "MD": "+373", "MC": "+377", "MN": "+976",
        "ME": "+382", "MS": "+1-664", "MZ": "+258", "MM": "+95", "NA": "+264", "NR": "+674", "CX": "+61", "NP": "+977",
        "NI": "+505", "NE": "+227", "NI": "+505", "NE": "+227", "NG": "+234", "NU": "+683", "NF": "+672", "NO": "+47", "NC": "+687",
        "NZ": "+64", "OM": "+968", "NL": "+31", "PK": "+92", "PW": "+680", "PS": "+970", "PA": "+507", "PG": "+675", "PY": "+595",
        "PE": "+51", "PN": "+870", "PF": "+689", "PL": "+48", "PT": "+351", "PR": "+1", "GB": "+44", "RW": "+250", "RO": "+40",
        "RU": "+7", "WS": "+685", "AS": "+1-684", "BL": "+590", "KN": "+1-869", "SM": "+378", "MF": "+590", "SX": "+1-721", "PM": "+508",
        "VC": "+1-784", "SH": "+290", "LC": "+1-758", "ST": "+239", "SN": "+221", "RS": "+381", "SC": "+248", "SL": "+232", "SG": "+65",
        "SY": "+963", "SO": "+252", "LK": "+94", "ZA": "+27", "SD": "+249", "SS": "+211", "SE": "+46", "CH": "+41", "SR": "+597",
        "TH": "+66", "TW": "+886", "TZ": "+255", "TJ": "+992", "TL": "+670", "TG": "+228", "TK": "+690", "TO": "+676", "TT": "+1-868",
        "TN": "+216", "TC": "+1-649", "TM": "+993", "TR": "+90", "TV": "+688", "UA": "+380", "UG": "+256", "UY": "+598", "UZ": "+998",
        "VU": "+678", "VA": "+39", "VE": "+58",
    };

    return countryCodeMap[countryValue] || "+00"; // Devuelve el código del país o una cadena vacía si no se encuentra
}
